<template>
    <base-page :title="$t('l.community_manage')" icon="ios-home">
        <Row slot="extra" type="flex" justify="end">
            <Col>
                <res-view key-name="fun_community_add">
                    <Button type="primary" @click="preAdd">{{$t('l.create')}}</Button>
                </res-view>
            </Col>
            <Col class="margin-left-5">
                <Button @click="loadData()">{{$t('l.fresh')}}</Button>
            </Col>
            <Col>
                <Input class="margin-left-5 " v-model="table.page.keyword" search suffix="ios-search"
                       :placeholder="$t('l.remark19')"
                       @on-change="searchBlur" @on-search="loadData(1)"/>
            </Col>
        </Row>
        <template>
            <Row class="full">
                <Drawer :title="current.community.name" placement="left" :closable="true" width="70%"
                        v-model="current.show">
                    <community-detail v-if="current.show" :community="current.community"
                                      @on-refresh="onCommunityRefresh"></community-detail>
                </Drawer>
                <Split v-model="spliter.l_r" :min="0.2" :max="0.5">
                    <div slot="left" class="demo-split-pane no-padding full" style="overflow-y: auto">
                        <Tree :data="regionTree" :render="renderRegionTree"></Tree>
                        <Spin size="large" fix v-if="spin.region"></Spin>
                    </div>
                    <div slot="right" class="demo-split-pane" style="padding-left: 8px;">
                        <Row :gutter="5">
                            <Col span="6" v-for="(community,index) in table.data"
                                 :key="community.id" class="margin-bottom-10">
                                <Card class="bright-card">
                                    <p slot="title">
                                        <span class="community-name">{{community.name}}</span>
                                    </p>
                                    <Row slot="extra" type="flex" justify="end">
                                        <p  class="btn-context-menu">
                                            <res-view key-name="fun_community_update">
                                            <span class="menu-icon" :title="$t('l.unfold')" @click="showDetail(index)"><Icon
                                                    type="md-expand" size="20" color="#2b85e4"/></span>
                                                <span class="menu-icon" :title="$t('l.edit')" @click="preEdit(index)"><Icon
                                                        size="22" type="ios-create-outline" color="orange"/></span>
                                            </res-view>
                                            <!--<res-view key-name="fun_community_delete">-->
                                            <!--<span class="menu-icon" title="删除" @click="preDelete(index)"><Icon type="md-close" color="red"/></span>-->
                                            <!--</res-view>-->
                                        </p>
                                    </Row>
                                    <p class="location-class" v-if="community.j_region">
                                        {{community.j_region.province?community.j_region.province.name:''}}
                                        {{community.j_region.city?community.j_region.city.name:''}}
                                        {{community.j_region.area?community.j_region.area.name:''}}
                                    </p>
                                    <p class="location-class" v-if="community.address">{{community.address}}</p>
                                    <p class="location-class" v-else>{{$t('l.remark20')}}</p>
                                </Card>
                            </Col>
                            <Spin size="large" fix v-if="spin.community"></Spin>
                        </Row>
                        <Row type="flex" justify="center">
                            <Col>
                                <Page size="small"
                                      :current="table.page.current"
                                      :page-size="table.page.size"
                                      :total="table.page.total"
                                      :page-size-opts="table.page.sizeOptions"
                                      show-elevator show-sizer show-total
                                      @on-page-size-change="pageSizeChange"
                                      @on-change="loadData($event)">
                                </Page>
                            </Col>
                        </Row>
                    </div>
                </Split>
            </Row>
        </template>
        <template>
            <lg-modal :title="modal.title" :show="modal.show" :loading="modal.loading" @on-submit="onSubmit('modal')"
                      @on-cancel="modal.loading=false;modal.show = false;">
                <Form :model="modal" :label-width="80" ref="modal" label-position="left">
                    <FormItem prop="community.name" :label="$t('l.name1')"
                              :rules="{ required: true, message: $t('l.remark33'), trigger: 'blur' }">
                        <Input v-model="modal.community.name" :placeholder="$t('l.community_name')"></Input>
                    </FormItem>
                    <FormItem prop="selectedRegion" :label="$t('l.region_of')"
                              :rules="{ required: true, message: $t('l.remark33'), trigger: 'blur',type:'array',min:2 }">
                        <Cascader v-model="modal.selectedRegion" trigger="hover" :data="regionTree"
                                  :placeholder="$t('l.region')" @on-change="onSelectedRegionChange"></Cascader>
                    </FormItem>
                    <FormItem :label="$t('l.address')">
                        <Input v-model="modal.community.address" :placeholder="$t('l.remark21')"></Input>
                    </FormItem>
                    <FormItem :label-width="190" prop="community.qr_refresh_times" :label="$t('l.remark22')"
                              :rules="{ required: true, message: $t('l.remark33'), trigger: 'blur' ,type:'number'}">
                        <InputNumber v-model="modal.community.qr_refresh_times" :min="0"
                                     :placeholder="$t('l.remark23')"></InputNumber>
                    </FormItem>
                    <p class="explain">{{$t('l.warn_note')}}：{{$t('l.explain7')}}</p>
                </Form>
            </lg-modal>
        </template>
    </base-page>
</template>

<script>
    import ResView from "../my-components/res-view";
    import BasePage from "../my-components/base-page";
    import util from '@/libs/util';
    import LgModal from "../my-components/lg-modal";
    import CommunityDetail from "./components/community-detail";

    export default {
        name: 'page-community',
        components: {CommunityDetail, LgModal, BasePage, ResView},
        data() {
            return {
                spliter: {
                    l_r: 0.2,
                    t_b: 0.5
                },
                regionTree: [],
                table: {
                    columns: [
                        {
                            title: this.$t('l.job_num'),
                            key: 'job_num'
                        },
                        {
                            title: this.$t('l.operation'),
                            slot: 'action',
                            width: 150,
                            align: 'center'
                        }
                    ],
                    data: [],
                    page: {
                        current: 1,
                        size: 12,
                        sizeOptions: [12, 16, 24],
                        total: 0,
                        sortKey: 'id',
                        sortMethod: 'desc',
                        keyword: ''
                    }
                },
                modal: {
                    show: false,
                    title: this.$t('l.community'),
                    loading: false,
                    selectedRegion: [], // 临时用 cascader选中的区域 id
                    j_region_temp: {},
                    currentIndex: -1,
                    community: {
                        name: '',
                        qr_refresh_times: 5,
                        j_region: {},
                        address: '',
                        city_id: 0
                    }
                },
                current: {
                    region: {},
                    regionLevel: null,
                    community: {},
                    show: false,
                    index: -1
                },
                spin: {
                    region: false,
                    community: false
                }
            };
        },
        methods: {
            loadData(page) {
                this.spin.community = true;
                util.ajax.get('/community/list', {
                    params: {
                        page: page || this.table.page.current,
                        size: this.table.page.size,
                        orderKey: this.table.page.sortKey,
                        orderMethod: this.table.page.sortMethod,
                        regionId: this.current.region.id,
                        regionLevel: this.current.regionLevel,
                        keyword: this.table.page.keyword
                    }
                }).then(res => {
                    this.spin.community = false;
                    this.setPage(res.data)
                })
            },
            searchBlur() {
                if (!this.table.page.keyword) this.loadData();
            },
            pageSizeChange(val) {
                this.table.page.size = val
                this.loadData(1);
            },
            setPage(pageInfo) {
                pageInfo.list.forEach(c => {
                    c.j_region = JSON.parse(c.j_region)
                })
                this.table.data = pageInfo.list;
                this.table.page.current = pageInfo.pageNumber;
                this.table.page.total = pageInfo.totalRow;
            },
            renderRegionTree(h, {root, node, data}) {
                return h('span', {
                    class: {
                        'tree-line': true,
                        'active': this.current.region === data
                    },
                    on: {
                        click: () => {
                            let selected = [data.id];
                            let j_region = {
                                province: {
                                    id: data.id,
                                    name: data.name
                                }
                            };
                            this.current.regionLevel = 'province';
                            if (node.parent) {
                                let pNode = root[node.parent];
                                selected.unshift(pNode.node.id);

                                j_region.city = j_region.province;
                                j_region.province = {
                                    id: pNode.node.id,
                                    name: pNode.node.name
                                }
                                this.current.regionLevel = 'city';
                                if (pNode.parent) {
                                    let gNode = root[pNode.parent];
                                    selected.unshift(gNode.node.id);

                                    j_region.area = j_region.city;
                                    j_region.city = j_region.province;
                                    j_region.province = {
                                        id: gNode.node.id,
                                        name: gNode.node.name
                                    }
                                    this.current.regionLevel = 'area';
                                }
                            }
                            if (this.current.region.id === data.id) {
                                this.modal.j_region_temp = {};
                                this.modal.selectedRegion = [];
                                this.current.region = {};
                                this.current.regionLevel = null;
                            } else {
                                this.modal.j_region_temp = j_region;
                                this.modal.selectedRegion = selected;
                                this.current.region = data;
                            }

                            this.loadData(1);
                        }
                    }
                }, data.name)
            },
            onSelectedRegionChange(value, selectedData) {
                if (selectedData[0]) {
                    this.modal.community.j_region.province = {
                        id: selectedData[0].id,
                        name: selectedData[0].name
                    }
                }
                if (selectedData[1]) {
                    this.modal.community.j_region.city = {
                        id: selectedData[1].id,
                        name: selectedData[1].name
                    }
                    //  选择特殊城市city_id特殊处理 ，上海、北京、澳门、香港
                    if (selectedData[0].id == 8 || selectedData[0].id == 13 || selectedData[0].id == 15 || selectedData[0].id == 25) {
                        this.modal.community.city_id = selectedData[0].city_id
                    } else {
                        this.modal.community.city_id = selectedData[1].city_id
                    }
                }
                if (selectedData[2]) {
                    this.modal.community.j_region.area = {
                        id: selectedData[2].id,
                        name: selectedData[2].name
                    }
                }
            },
            setTreeMap(tree, map) {
                tree.forEach(node => {
                    map[node.id.toString()] = node;
                    if (node.children) this.setTreeMap(node.children, map);
                })
            },
            show(index) {
                this.$Modal.info({
                    title: 'User Info',
                    content: `Name：${this.table.data[index].name}<br>Age：${this.table.data[index].age}<br>Address：${this.table.data[index].address}`
                })
            },
            remove(index) {
                this.table.data.splice(index, 1);
            },
            preAdd() {
                this.modal.community = {
                    name: '',
                    address: '',
                    j_buildings: [],
                    qr_refresh_times: 5,
                    j_region: this.modal.j_region_temp
                }
                this.modal.title = this.$t('l.create_community');
                this.modal.show = true;
            },
            preEdit(index) {
                this.modal.currentIndex = index;
                let comm = this.modal.community = util.deepCopy(this.table.data[index]);
                let selectedRegion = this.modal.selectedRegion = [];
                if (comm.j_region.province) selectedRegion.push(comm.j_region.province.id);
                if (comm.j_region.city) selectedRegion.push(comm.j_region.city.id);
                if (comm.j_region.area) selectedRegion.push(comm.j_region.area.id);
                this.modal.title = this.$t('l.community_info');
                this.modal.show = true;
            },
            preDelete(index) {
                let comm = this.table.data[index];
                util.ajax.delete('/community/delete', {params: {id: comm.id}}).then(res => {
                    this.loadData();
                })
            },
            showDetail(index) {
                this.current.index = index;
                this.current.community = util.deepCopy(this.table.data[index]);
                this.current.community.j_buildings = util.parseJSON(this.current.community.j_buildings, []);
                this.current.show = true;
            },
            setSelected(departs) {
                if (!this.modal.user.j_depart_ids.length) return;
                departs.forEach(depart => {
                    if (this.modal.user.j_depart_ids.includes(depart.id)) {
                        depart.checked = true;
                    }
                    depart.expand = true;
                    if (depart.children) this.setSelected(depart.children);
                })
            },
            onSubmit(name) {
                this.$refs[name].validate(valid => {
                    if (valid) {
                        this.modal.loading = true;
                        let community = this.modal.community;
                        if (community.id) {
                            util.ajax.put('/community/update', community).then(res => {
                                this.modal.loading = false;
                                if (!res.code) {
                                    this.modal.show = false;
                                    this.table.data.splice(this.modal.currentIndex, 1, this.modal.community);
                                    this.modal.currentIndex = -1;
                                    this.modal.selectedRegion = []
                                    this.$Message.success(this.$t('l.edit_success'));
                                }
                            })
                        } else {
                            util.ajax.post('/community/add', community).then(res => {
                                this.modal.loading = false;
                                if (!res.code) {
                                    this.modal.show = false;
                                    this.modal.selectedRegion = []
                                    this.loadData();
                                    this.$store.commit("addUserCommunity", community)
                                    this.$Message.success(this.$t('l.add_success'));
                                }
                            })
                        }
                    } else {
                        this.$Message.error(this.$t('l.remark24'));
                    }
                })
            },
            onCommunityRefresh(community) {
                this.table.data[this.current.index].j_buildings = community.j_buildings;
                this.showDetail(this.current.index);
            },

        },
        created() {
            this.spin.region = true;
            util.ajax.get('/region/list').then(res => {
                this.spin.region = false;
                this.regionTree = res.data;
            })
            this.loadData();
        },
        mounted() {

        },
    };

</script>

<style lang="less" scoped>
    .btn-context-menu {
        & span.menu-icon {
            cursor: pointer;
            margin: 0 3px;
            & > i {
                transition: transform 0.3s;
            }
            &:hover > i {
                transform: rotateY(180deg);
            }
        }
    }

    .community-name {
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        width: 70%;
    }

    .location-class {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-weight: 600;
    }
</style>
